<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <loading :isLoading="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('contas-receber') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('financeiro') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('contas-receber') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="filters-bar mb-3">
                        <div class="filters-bar-form form-columns-fit">
                            <div class="columns">
                                <div class="column is-3">
                                    <search-bar
                                        :clean="limparBusca"
                                        :onSearch="debouncedOnSearch"
                                        :tooltipLabel="
                                            $t('msg-campo-busca-n', {
                                                n: `${$t('codigo')}, ${$t('nome')}, ${$t(
                                                    'rsocial'
                                                )} e ${$t('numero-titulo')}`,
                                            })
                                        "
                                    />
                                </div>
                                <div class="column is-3">
                                    <v-input
                                        class="input-size"
                                        v-model="valor"
                                        @input="debouncedOnSearchValor"
                                        placeholder="busca"
                                        :maxlength="20"
                                        title="valor-do-titulo"
                                        :uppercase="false"
                                    />
                                </div>
                                <!-- Data Inicio-->
                                <div class="column is-3">
                                    <verified-date-picker
                                        dateType="startDate"
                                        :value="datainicial"
                                        :endDate="datafinal"
                                        title="data-vencimento-inicio"
                                        @input="changeStartDate"
                                        :showClean="false"
                                        :invalid="datainicial == null"
                                    />
                                </div>
                                <!-- Data Fim-->
                                <div class="column is-3">
                                    <verified-date-picker
                                        dateType="endDate"
                                        :value="datafinal"
                                        :startDate="datainicial"
                                        title="data-vencimento-fim"
                                        @input="changeEndDate"
                                        :showClean="false"
                                        :invalid="datafinal == null"
                                        :addDateYears="2"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="filters-bar-actions">
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="showFiltros = !showFiltros"
                                v-tippy
                                :title="$t('filtros')"
                            />
                            <b-button
                                class="ml-2"
                                type="is-primary"
                                icon-right="chart-bar"
                                @click="
                                    $router.push({
                                        name: 'ven-contas-receber-chart',
                                        params: {
                                            mesInicio: datainicial,
                                            mesFim: datafinal,
                                        },
                                    })
                                "
                                v-tippy
                                :title="$t('chart')"
                            />
                        </div>
                    </div>
                    <!-- LISTAGEM -->
                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="centroCusto"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                            striped
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="$t(f.key) || ''"
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                :visible="f.visible"
                                :cell-class="f.cellClass"
                                v-slot="props"
                            >
                                <!-- <div v-if="f.key == 'label'" class="label-situacao"> -->
                                <div
                                    v-if="f.key == 'label'"
                                    class="bar"
                                    :class="[
                                        props.row.dias_vencido == 0
                                            ? 'bar-a-vencer'
                                            : 'bar-vencido',
                                    ]"
                                    v-tippy
                                    :title="
                                        $t(
                                            props.row.dias_vencido == 0
                                                ? 'titulo-a-vencer'
                                                : 'titulo-vencido'
                                        )
                                    "
                                />
                                <!-- </div> -->
                                <a
                                    v-else-if="f.key == 'codigo'"
                                    @click="
                                        $router.push({
                                            params: {
                                                id: props.row.idtitulo,
                                            },
                                            name: 'ven-contas-receber-detail',
                                        })
                                    "
                                >
                                    {{ props.row.idtituloerp }}
                                </a>
                                <span v-else-if="f.key == 'nome'">
                                    {{ props.row.cliente.nome }}
                                </span>
                                <span v-else-if="f.key == 'rsocial'">
                                    {{ props.row.cliente.rsocial }}
                                </span>
                                <span v-else-if="f.key == 'numero-titulo'">
                                    {{ props.row.numerotitulo }}
                                </span>
                                <span v-else-if="f.key == 'data-vencimento'">
                                    {{ props.row.datavencimento | moment('L') }}
                                </span>
                                <span v-else-if="f.key == 'valor'" :title="props.row.valortitulo">
                                    {{ props.row.valortitulo | decimal(null, true) }}
                                </span>
                                <span v-else-if="f.key == 'anotacoes'">
                                    <div class="is-flex is-flex-hcenter">
                                        <b-button
                                            type="is-success"
                                            icon-right="note-plus"
                                            @click="
                                                () => {
                                                    idTitulo = props.row.idtitulo;
                                                    anotacao = null;

                                                    showAnotacaoManage = true;
                                                    const anotacaoInput = $refs.anotacaoInput;
                                                    const inputInsideComponent =
                                                        anotacaoInput.$refs.typed;
                                                    inputInsideComponent.focus();
                                                }
                                            "
                                            v-tippy
                                            :title="$t('criar-anotacao')"
                                        />
                                    </div>
                                </span>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <div class="totalizador-titulos">
                        <div>
                            <div>
                                <label class="capitalized">{{ $t('total-corrigido') }}:</label>
                                {{ parseAsCurrency(tituloRodape.totalContasReceberCorrigido) }}
                            </div>
                            <div>
                                <label class="capitalized">{{ $t('vencidos') }}:</label>
                                {{ parseAsCurrency(tituloRodape.totalContasReceberVencidas) }}
                            </div>
                            <div>
                                <label class="capitalized">{{ $t('a-vencer') }}:</label>
                                {{ parseAsCurrency(tituloRodape.totalContasReceberVencer) }}
                            </div>
                            <div>
                                <label class="capitalized">{{ `% ${$t('vencidos')}` }}:</label>
                                {{ calculaPercentual(tituloRodape.qtdContasReceberVencidas) }}%
                            </div>
                        </div>
                        <div>
                            <div>
                                <label class="capitalized">{{ $t('total') }}:</label>
                                {{ parseAsCurrency(tituloRodape.totalContasReceber) }}
                            </div>
                        </div>
                        <div>
                            <div>
                                <label class="capitalized">{{ $t('qntde') }}:</label>
                                {{ tituloRodape.qtdContasReceber }}
                            </div>
                            <div>
                                <label class="capitalized">{{ $t('qntde') }}:</label>
                                {{ tituloRodape.qtdContasReceberVencidas }}
                            </div>
                            <div>
                                <label class="capitalized">{{ $t('qntde') }}:</label>
                                {{ tituloRodape.qtdContasReceberVencer }}
                            </div>
                            <div>
                                <label class="capitalized">{{ `% ${$t('a-vencer')}` }}:</label>
                                {{ calculaPercentual(tituloRodape.qtdContasReceberVencer) }}%
                            </div>
                        </div>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>

            <lateral-content :isLoading="isLoading" v-model="showAnotacaoManage" compact footer>
                <div class="column">
                    <v-textarea
                        ref="anotacaoInput"
                        v-model="anotacao"
                        title="nova-anotacao"
                        :rows="4"
                        :maxRows="6"
                        :invalid="isNull(anotacao)"
                        :disabled="isSaving"
                        disableTransform
                        required
                    />
                </div>
                <template v-slot:footer-right>
                    <b-button
                        type="is-primary"
                        @click="saveAnotacao"
                        :disabled="isSaving || isAnotacaoFromERP"
                    >
                        {{ $t('salvar') }}
                    </b-button>
                </template>
            </lateral-content>

            <!-- Filtro lateral -->
            <div
                ref="listaFiltros"
                class="filtros-right"
                :class="{ 'hide-filtros-right': !showFiltros }"
                v-show="!isLoading"
            >
                <div class="filtros-container form-columns-fit">
                    <div class="columns is-multiline">
                        <div class="column is-12">
                            <vss-select
                                ref="situacaoInput"
                                title="situacao"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                :mlLabels="true"
                                clearable
                                @input="onCleanSituacao"
                            />
                        </div>

                        <div class="column is-12">
                            <vss-select
                                ref="clienteSelect"
                                title="cliente"
                                v-model="clienteSelected"
                                :options="clienteSelect"
                                :loading="clienteLoading"
                                @search="loadCliente"
                                label="nome"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                            />
                        </div>

                        <div class="column is-12">
                            <vss-select
                                ref="formapagtoSelect"
                                title="formapagto"
                                v-model="formapagtoSelected"
                                :options="formapagtoSelect"
                                :loading="formapagtoLoading"
                                @search="loadFormaPagto"
                                label="descricao"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                            />
                        </div>
                    </div>
                </div>
                <div class="filtros-footer">
                    <div class="columns is-mobile">
                        <div class="column">
                            <b-button
                                type="is-warning is-silver"
                                icon-right="close"
                                @click="showFiltros = !showFiltros"
                                v-tippy
                                :title="$t('fechar')"
                            />
                        </div>
                        <div class="column">
                            <b-button
                                type="is-warning is-silver"
                                icon-right="backspace"
                                @click="onCleanFilters()"
                                class="float-right"
                            >
                                Limpar
                            </b-button>
                        </div>
                        <div class="column">
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="timeoutCarregarDados()"
                                class="float-right"
                            >
                                Filtrar
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContasReceberService from '@/services/vendas/financeiro/ContasReceberService';
import VendasClienteService from '@/services/VendasClienteService';
import FormaPagtoService from '@/services/FormaPagtoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('ven-contas-receber') && to.name != 'ven-contas-receber-list') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            centroCusto: [],
            service: new ContasReceberService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            formaPagtoService: new FormaPagtoService(this.$http, this.$router),

            fields: [
                {
                    key: 'label',
                    width: 5,
                    sortable: false,
                    sortFn: null,
                    visible: true,
                    cellClass: 'table-td-relative',
                },
                { key: 'codigo', width: null, sortable: true, visible: true, cellClass: null },
                { key: 'nome', width: null, sortable: true, visible: true, cellClass: null },
                { key: 'rsocial', width: null, sortable: true, visible: true, cellClass: null },
                { key: 'numero-titulo', width: null, sortable: true, visible: true, cellClass: null },
                {
                    key: 'data-vencimento',
                    width: null,
                    sortable: true,
                    sortFn: null,
                    visible: true, cellClass: null,
                },
                { key: 'valor', width: null, sortable: true, visible: true, cellClass: null },
                { key: 'anotacoes', width: 85, sortable: false, visible: true, cellClass: null },
            ],
            isLoading: false,
            isSaving: false,
            isEmpty: false,
            queryFilter: '',
            debouncedOnSearch: null,
            debouncedOnSearchValor: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            datainicial: (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setMonth(trintaDiasAtras.getMonth() - 3);
                return trintaDiasAtras;
            })(),
            datafinal: new Date(),
            showFiltros: false,
            limparBusca: false,
            situacaoSelect: [
                { label: 'todos', id: 2 },
                { label: 'titulo-vencido', id: 1 },
                { label: 'titulo-a-vencer', id: 0 },
            ],
            situacaoSelected: { label: 'todos', id: 2 },
            clienteSelect: [],
            clienteSelected: [],
            clienteLoading: false,
            formapagtoSelect: [],
            formapagtoSelected: [],
            formapagtoLoading: false,

            filters: {
                queryFilter: '.*',
                valor: '',
                datainicial: null,
                datafinal: null,
                column: 'nome',
                order: 'desc',
                situacao: 2,
                clienteList: [],
                formapagtoList: [],
                currentPage: 1,
                perPage: 10,
            },
            valor: '',
            idTitulo: 0,
            showAnotacaoManage: false,
            isAnotacaoFromERP: this.$store.state.user.tabelasERPWebServer.includes(
                'tituloanotacao'
            ),
            anotacao: null,
            tituloRodape: {
                totalContasReceber: 0,
                totalContasReceberVencidas: 0,
                totalContasReceberVencer: 0,
                qtdContasReceber: 0,
                qtdContasReceberVencidas: 0,
                qtdContasReceberVencer: 0,
            },
        };
    },
    created() {
        this.$cookies.set('ven-contas-receber', 'list');

        this.rotaAninhada =
            this.$route.name.includes('ven-contas-receber') &&
            this.$route.name != 'ven-contas-receber-list';

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'financeiro', 'ven-contas-receber');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'contas-receber' },
            });

        const anotacaoField = this.fields.find((field) => field.key === 'anotacoes');

        anotacaoField.visible = !this.isAnotacaoFromERP;

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.debouncedOnSearchValor = this.localDebounce(this.onSearchValor, 500);
        this.carregarDados();
        this.loadCliente();
        this.loadFormaPagto();
    },
    methods: {
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            if (date.getTime() != this.datainicial.getTime()) {
                this.datainicial = date;
                if (!this.isNull(this.datainicial)) this.carregarDados();
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.datafinal.getTime()) {
                this.datafinal = date;
                if (!this.isNull(this.datafinal)) this.carregarDados();
            }
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeToSearch(value);
            this.carregarDados(1);
        },
        onSearchValor() {
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.fillFilter(currentPage);

            this.service
                .findAll(this.filters)
                .then((body) => {
                    this.centroCusto = Object.assign(body.content.tituloList);
                    this.tituloRodape = body.content.tituloRelatorio;
                    this.pagination.totalRows = body.totalElements;
                    this.isEmpty = this.centroCusto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        fillFilter(currentPage = 1) {
            this.filters.clienteList = this.clienteSelected
                ? this.clienteSelected.map((e) => e.id)
                : [];
            this.filters.formapagtoList = this.formapagtoSelected
                ? this.formapagtoSelected.map((e) => e.id)
                : [];
            this.filters.situacao = this.situacaoSelected != null ? this.situacaoSelected.id : null;

            this.filters.perPage = this.pagination.perPage;
            this.filters.currentPage = currentPage;
            this.filters.queryFilter = this.queryFilter || '.*';
            this.filters.valor = this.reaisToFloat(this.valor);

            this.filters.datainicial = this.datainicial.getTime()
                ? this.$moment(this.datainicial).format('YYYY-MM-DD')
                : null;
            this.filters.datafinal = this.datafinal.getTime()
                ? this.$moment(this.datafinal).format('YYYY-MM-DD')
                : null;
        },
        loadCliente(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.clienteLoading = true;
            this.clienteService
                .findAllComboSituacao(2, query)
                .then((r) => {
                    return r.content.map((m) => {
                        return {
                            id: m.idcliente,
                            idcliente: m.idcliente,
                            nome: m.replicapda == 2 ? 'Inativo | ' + m.nome : m.nome,
                            replicapda: m.replicapda,
                        };
                    });
                })
                .then((r) => {
                    this.clienteSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        loadFormaPagto(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.formapagtoLoading = true;
            this.formaPagtoService
                .findAllComboSituacao(2, query)
                .then((r) => {
                    return r.content.map((m) => {
                        return {
                            id: m.idformapagto,
                            idformapagto: m.idformapagto,
                            descricao: m.situacao != 1 ? 'Inativo | ' + m.descricao : m.descricao,
                            situacao: m.situacao,
                        };
                    });
                })
                .then((r) => {
                    this.formapagtoSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.formapagtoLoading = false;
                });
        },
        onCleanSituacao(val) {
            if (!val) this.situacaoSelected = this.situacaoSelect[0];
        },
        onCleanFilters() {
            this.situacaoSelected = this.situacaoSelect[0];
            this.clienteSelected = [];
            this.formapagtoSelected = [];
            this.limparBusca = true;
            this.filters.search = '';
            this.filters.valor = '';
            this.datainicial = (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setMonth(trintaDiasAtras.getMonth() - 3);
                return trintaDiasAtras;
            })();
            this.datafinal = new Date();
            this.timeoutCarregarDados();
        },
        timeoutCarregarDados(time = 600) {
            this.showFiltros = false;
            setTimeout(() => {
                this.carregarDados();
                this.limparBusca = false;
            }, time);
        },
        saveAnotacao() {
            if (this.isNull(this.anotacao)) {
                this.$refs.anotacaoInput.focusedOut = true;

                return;
            }

            this.isSaving = true;

            this.$axios
                .post(`/titulo-anotacao`, {
                    idtitulo: this.idTitulo,
                    usuario: this.$store.state.user.nome,
                    anotacao: this.anotacao,
                })
                .then((_) => {
                    this.idTitulo = 0;
                    this.anotacao = null;
                    this.showAnotacaoManage = false;

                    this.$root.showMessage('success', 'msg-anotacao-salvou-sucesso');
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage('error', 'erro-salvar-anotacao');
                })
                .finally((_) => (this.isSaving = false));
        },
        calculaPercentual(valor) {
            const percentualDoTotal = (valor * 100) / this.tituloRodape.qtdContasReceber;

            return this.getDecimal(percentualDoTotal, 0);
        },
        reaisToFloat(value) {
            const currency = value.replace(/\D/g, '');

            return value.includes(',') ? parseFloat(currency) / 100 : parseFloat(currency);
        },
        localDebounce(func, wait) {
            let timeout;

            return function (...args) {
                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    func.apply(this, args);
                }, wait);
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.input-size ::v-deep .v-input {
    height: 40px;
}

.capitalized {
    text-transform: capitalize;
}

.totalizador-titulos {
    background-color: #f9f9f9;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    opacity: 0.7;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    & > div {
        padding: 16px;
        label {
            color: $sovis-black;
            font-size: 1em;
            padding-right: 10px;
        }
        @media screen and (max-width: 750px) {
            padding: 2px 10px;
        }
    }
    @media screen and (max-width: 750px) {
        flex-direction: column;
    }
}

#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
        .bar {
            position: absolute;
            top: 5px;
            bottom: 5px;
            left: 5px;
            right: 5px;
            border-radius: 100px;
            width: 5px;
            min-height: 25px;
            &.bar-a-vencer {
                background-color: #84bd42;
            }
            &.bar-vencido {
                background-color: #fd5858;
            }
        }
    }
    // Filtro lateral
    $width: 400px;
    .filtros-right {
        z-index: 100;
        padding: 15px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        background-color: $darker-bg-color;
        width: $width;
        height: 80%;
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-top: solid 1px #d9d9d9;
        border-left: solid 1px #d9d9d9;
        border-bottom: solid 1px #d9d9d9;
        transition: 0.6s;
        -webkit-box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
        box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);

        .filtros-container {
            margin-bottom: 60px;
        }

        .filtros-footer {
            border-bottom-left-radius: 5px;
            background-color: #fff;
            position: absolute;
            padding: 10px;
            bottom: 0;
            left: 0;
            right: 0;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);

            .is-silver {
                color: $semi-title-color;
                box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                @include exclude-button();
            }
        }
    }
    .hide-filtros-right {
        margin-right: -$width;
    }
    @media screen and (min-height: 850px) {
        .filtros-right {
            height: 50%;
        }
    }
    @media screen and (max-width: 640px) {
        $width: 95%;
        .filtros-right {
            width: $width;
        }
        .hide-filtros-right {
            margin-right: -$width;
        }
    }
}
</style>
